<template>
  <common-alert type="danger"
                :title="$t('oauth2_implements.WechatError.wechatError1')"
                :title-img="error"
                :btn-text="$t('oauth2_implements.WechatError.tryAgain')"
                :on-click="gotoScan">
    <p>{{ $t('oauth2_implements.WechatError.wechatError2') }}</p>
  </common-alert>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'
import CommonAlert from './CommonAlert.vue'
import error from './assets/imgs/error.png'

const router = useRouter()
const gotoScan = () => {
  router.push('/oauth2/third_parties/wechat')
}
</script>